// extracted by mini-css-extract-plugin
export var actions = "_en-g";
export var benefitCard = "_en-b";
export var benefitIcon = "_en-d";
export var benefitLabel = "_en-f";
export var benefits = "_en-a";
export var benefitsSection = "_en-8";
export var bodyText = "_en-7";
export var closeButton = "_en-2";
export var content = "_en-3";
export var eyebrow = "_en-4";
export var heading = "_en-5";
export var image = "_en-i";
export var imagePanel = "_en-h";
export var modal = "_en-0";
export var offerCard = "_en-c";
export var offerIcon = "_en-e";
export var sectionLabel = "_en-9";
export var shell = "_en-1";
export var title = "_en-6";